import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Airport } from "./Airport/Airport";
import { Level } from "./Levels/Level";
import { Outlet } from "./Outlet/Outlet";

export const StoreLocations = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeTab) {
      navigate(`/dedicated/eraman/storeLocations?activeTab=airport`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  const tabItems = [
    {
      label: "Airport",
      key: "airport",
      children: <Airport />,
    },
    {
      label: "Outlet",
      key: "outlet",
      children: <Outlet />,
    },
    {
      label: "Level",
      key: "level",
      children: <Level />,
    },
  ];

  const handleActionButton = (tabKey: string) => {
    switch (tabKey) {
      case "airport":
        return (
          <Button
            onClick={() => navigate("/dedicated/eraman/storeLocations/airport/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Airport
          </Button>
        );
      case "level":
        return (
          <Button
            onClick={() => navigate("/dedicated/eraman/storeLocations/level/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Level
          </Button>
        );
      case "outlet":
        return (
          <Button
            onClick={() => navigate("/dedicated/eraman/storeLocations/outlet/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Outlet
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <ContentWrapper
      title="Store Locations"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleActionButton(activeTab || "airport")}
    >
      <Tabs
        activeKey={activeTab || "airport"}
        items={tabItems}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=${key}`)}
      />
    </ContentWrapper>
  );
};
